"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useControllable;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _usePrevious = _interopRequireDefault(require("react-utils/hooks/usePrevious"));

/**
 * A hook for implementing the controllable pattern.
 *
 * @param {*} value The current value of the controllable property
 * @param {*} defaultValue The default value of the controllable property
 * @param {Function} onChange An external handler to fire when `handleChange` is called
 * @return {Array} An array of the form `[computedValue, handleChange]`
 */
function useControllable(value, defaultValue, onChange) {
  var _useState = (0, _react.useState)(defaultValue),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      stateValue = _useState2[0],
      setStateValue = _useState2[1]; // Store `onChange` in a ref so that our `handleChange` can be a constant


  var onChangeRef = (0, _react.useRef)();
  onChangeRef.current = onChange; // Compute the return value

  var computedValue = value !== undefined ? value : stateValue;
  var handleChange = (0, _react.useCallback)(function (evt) {
    setStateValue(evt.target.value);
    if (onChangeRef.current) onChangeRef.current(evt);
  }, []); // Edge case: If `value` has become `undefined`, reset the state value to the default

  var prevValue = (0, _usePrevious.default)(value);

  if (prevValue !== value && value === undefined && stateValue !== defaultValue) {
    setStateValue(defaultValue);
  }

  return [computedValue, handleChange];
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/hooks/useControllable.js
// module id = 383
// module chunks = 5 6 7